export default "__VITE_ASSET__X3x9SimR__"